export { Structure as default } from '@portal-internet/components';
